/**
 * @fileoverview Neighborhood select and profile toggle for the second company address.
 */

import React from "react";
import { IconButton } from "@mui/material";
import ToggleOffIcon from "@mui/icons-material/ToggleOff";
import ToggleOnIcon from "@mui/icons-material/ToggleOn";
import styles from "./Location.module.css";
import Select from "react-select";
import { logger } from "../../../utils/logger.js";
import { getLocationSelectStyles, getSafeSelectedOption } from "./locationSelectUtils";
import {
  CURSOR_NOT_ALLOWED,
  SHOW_IN_PROFILE_KEY,
  TOGGLE_COLOR_ACTIVE,
  TOGGLE_COLOR_INACTIVE,
} from "./locationConstants";

const SecondAddressNeighborhoodSelect = ({ model, t }) => {
  const {
    handleInputChange, handleToggleChange,
    isAddressReadOnly, secondAddressNeighborhoodRef,
    generalTowns, generalZipCodes,
    setSecondAddressZipCodes, generalNeighborhoods,
    secondAddressNeighborhoods, setSecondAddressNeighborhoods,
    setSegundoDomicilioCodigoPostal, segundoDomicilioColonia,
    setSegundoDomicilioColonia, segundoDomicilioMostrarColonia,
    setSegundoDomicilioMostrarColonia, setSegundoDomicilioMunicipio,
    setSegundoDomicilioEstado,
  } = model;

  return (
    <div className={`${styles.inputGroup} ${styles.twoLabelsGroup}`}>
      <div className={styles.inputGroup}>
        <label className={styles.inputLabel}>
          {t("components.location.neighborhoodLabel")}
        </label>
        <Select
          ref={secondAddressNeighborhoodRef}
          isSearchable={true}
          isDisabled={true}
          value={getSafeSelectedOption(
            secondAddressNeighborhoods,
            segundoDomicilioColonia,
          )}
          onChange={(selectedOption) => {
            logger.info("+++ Second Neighborhood selectedOption:", {
              data: selectedOption,
            });
            if (!selectedOption) {
              return;
            }

            setSegundoDomicilioColonia(selectedOption._id);
            handleInputChange("domicilio2Colonia", selectedOption._id);

            const filteredNeighborhoods = generalNeighborhoods.filter(
              (neighborhood) =>
                neighborhood.idCodigoPostal ==
                  selectedOption.idCodigoPostal &&
                neighborhood.idMunicipio == selectedOption.idMunicipio,
            );
            logger.info(
              "onChange secondNeighborhood filteredNeighborhoods:",
              { data: filteredNeighborhoods },
            );
            setSecondAddressNeighborhoods(filteredNeighborhoods);

            const filteredZipCodes = generalZipCodes.filter(
              (zipcode) => zipcode._id == selectedOption.idCodigoPostal,
            );
            logger.info("onChange secondNeighborhood filteredZipCodes:", {
              data: filteredZipCodes,
            });
            setSecondAddressZipCodes(filteredZipCodes);

            const filteredTowns = generalTowns.filter(
              (town) => town._id == selectedOption.idMunicipio,
            );
            logger.info("onChange secondNeighborhood filteredTowns:", {
              data: filteredTowns,
            });

            setSegundoDomicilioCodigoPostal(selectedOption.idCodigoPostal);
            handleInputChange(
              "domicilio2CodigoPostal",
              selectedOption.idCodigoPostal,
            );

            setSegundoDomicilioMunicipio(selectedOption.idMunicipio);
            handleInputChange(
              "domicilio2Municipio",
              selectedOption.idMunicipio,
            );

            setSegundoDomicilioEstado(String(filteredTowns[0].idEstado));
            handleInputChange(
              "domicilio2Estado",
              String(filteredTowns[0].idEstado),
            );
          }}
          options={secondAddressNeighborhoods}
          placeholder={t("components.location.neighborhoodPlaceholder")}
          styles={getLocationSelectStyles()}
          className="select__control"
          getOptionValue={(option) => option._id}
          formatOptionLabel={(option) => <span>{option.nombre}</span>}
        />
        <div className={styles.showInProfileContainer}>
          <span className={styles.showInProfileText}>
            {t(SHOW_IN_PROFILE_KEY)}
          </span>
          <IconButton
            onClick={() => {
              setSegundoDomicilioMostrarColonia(
                !segundoDomicilioMostrarColonia,
              );
              handleToggleChange(
                "domicilio2MostrarColonia",
                !segundoDomicilioMostrarColonia,
              );
            }}
            size="small"
            disabled={isAddressReadOnly}
            className={styles.toggleButton}
            sx={{
              "&.Mui-disabled": {
                cursor: CURSOR_NOT_ALLOWED,
                pointerEvents: "auto",
              },
              "& .MuiSvgIcon-root": {
                color: segundoDomicilioMostrarColonia
                  ? TOGGLE_COLOR_ACTIVE
                  : TOGGLE_COLOR_INACTIVE,
              },
            }}
          >
            {segundoDomicilioMostrarColonia ? (
              <ToggleOnIcon />
            ) : (
              <ToggleOffIcon />
            )}
          </IconButton>
        </div>
      </div>
    </div>
  );
};

export default SecondAddressNeighborhoodSelect;
